module.exports = __webpack_public_path__ + "img/play.daa21dce.svg";